<template>
  <div class="services">
    <div class="wrapper">
      <LabeledTitle :content="content.hero" />
      <IntroText :content="content.intro.htmltext" class="services__intro" />
    </div>

    <Castle
      :config="{
        isConfigurable: false,
        scrollIn: true,
        rotation: true,
        colors: {
          primary,
          secondary,
        },
      }"
      class="services__castle-top"
    />

    <List :content="content.steps" class="services__list" />

    <Castle
      :config="{
        isConfigurable: false,
        scrollIn: true,
        rotation: true,
        reversed: true,
        colors: {
          primary,
          secondary,
        },
      }"
      class="services__castle-bottom"
    />

    <div class="wrapper">
      <Methods :content="content.cycle" class="services__methods" />
      <ScrollGallery
        :content="content.polaroids"
        class="mb-d services__gallery"
      />
      <hr />

      <Cta :content="content.cta" class="m-d" />
    </div>
  </div>
</template>

<script setup lang="ts">
import Cta from '@/components/ui/Cta.vue'
import ScrollGallery from '@/components/ui/ScrollGallery.vue'
import Castle from '@/components/castle/Castle.vue'
import LabeledTitle from '@/components/ui/LabeledTitle.vue'
import IntroText from '@/components/ui/IntroText.vue'
import List from '@/components/services/List.vue'
import Methods from '@/components/services/Methods.vue'
import { Color } from 'three'
import { onBeforeMount, ref } from 'vue'

const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
})

const primary = ref()
const secondary = ref()

onBeforeMount(() => {
  primary.value = new Color(props.content.colors.foreground)
  secondary.value = new Color(props.content.colors.background)
})
</script>

<style lang="scss" scoped>
.services {
  overflow: hidden;
}

.services__castle-top,
.services__castle-bottom {
  pointer-events: none;
  min-height: 50rem;
}
</style>
